/* tslint:disable */
/* eslint-disable */
/**
 * MAPIIO API
 * API mapové aplikace Mapiio pro klientskou JavaScriptovou / React část.
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { JsonImportCheckVO } from '../model';
// @ts-ignore
import { JsonImportProgressVO } from '../model';
// @ts-ignore
import { JsonImportRunVO } from '../model';
// @ts-ignore
import * as Objs from './index'
// @ts-ignore
import { DataResponseVO, DataRequestVO, ExportRequestVO } from '@mc/data-filter-react';

/**
 * JsonImportControllerApi - axios parameter creator
 * @export
 */
export const JsonImportControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Vrátí průběžný stav úlohy importu/aktualizace běžící na pozadí
         * @param {string} jobId identifikátor úlohy vrácený při spuštění importu/aktualizace
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getJsonImportProgress: async (jobId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'jobId' is not null or undefined
            assertParamExists('getJsonImportProgress', 'jobId', jobId)
            const localVarPath = `/api/import/json/progress/{jobId}`
                .replace(`{${"jobId"}}`, encodeURIComponent(String(jobId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Vrátí poslední známý průběh importu/aktualizace pro danou vrstvu (běžící i nedávno dokončený), aby ho bylo možné zobrazit v detailu vrstvy i po zavření okna importu. Prázdné, pokud pro vrstvu žádná úloha není evidována.
         * @param {number} layerId ID vrstvy
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getJsonImportProgressForLayer: async (layerId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'layerId' is not null or undefined
            assertParamExists('getJsonImportProgressForLayer', 'layerId', layerId)
            const localVarPath = `/api/import/json/progress-for-layer/{layerId}`
                .replace(`{${"layerId"}}`, encodeURIComponent(String(layerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Spustí na pozadí import dat ze nahraného souboru (včetně obrázků) podle zvolených akcí (vložení nových a/nebo aktualizace existujících objektů). Pokud není předáno ID vrstvy, nejprve se založí nová vrstva podle pevné definice. Vrátí okamžitě stav úlohy s jobId; průběh se zjišťuje přes /api/import/json/progress.
         * @param {JsonImportRunVO} [jsonImportRunVO] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        runJsonImport: async (jsonImportRunVO?: JsonImportRunVO, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/import/json/run`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(jsonImportRunVO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Nahraje JSON soubor POV, projde ho a vrátí počty objektů, které se založí a které se aktualizují (ztotožnění přes externí id). Bez parametru layerId jde o import do nové vrstvy (vrstva se založí podle pevné definice až při spuštění importu) – všechny objekty jsou pak nové.
         * @param {number} [layerId] ID cílové vrstvy; prázdné &#x3D; import do nové vrstvy
         * @param {File} [file] JSON soubor s daty
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadJson: async (layerId?: number, file?: File, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/import/json/upload`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            if (layerId !== undefined) {
                localVarQueryParameter['layerId'] = layerId;
            }


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * JsonImportControllerApi - functional programming interface
 * @export
 */
export const JsonImportControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = JsonImportControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * Vrátí průběžný stav úlohy importu/aktualizace běžící na pozadí
         * @param {string} jobId identifikátor úlohy vrácený při spuštění importu/aktualizace
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getJsonImportProgress(jobId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<JsonImportProgressVO>> {

            const localVarAxiosArgs = await localVarAxiosParamCreator.getJsonImportProgress(jobId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Vrátí poslední známý průběh importu/aktualizace pro danou vrstvu (běžící i nedávno dokončený), aby ho bylo možné zobrazit v detailu vrstvy i po zavření okna importu. Prázdné, pokud pro vrstvu žádná úloha není evidována.
         * @param {number} layerId ID vrstvy
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getJsonImportProgressForLayer(layerId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<JsonImportProgressVO>> {

            const localVarAxiosArgs = await localVarAxiosParamCreator.getJsonImportProgressForLayer(layerId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Spustí na pozadí import dat ze nahraného souboru (včetně obrázků) podle zvolených akcí (vložení nových a/nebo aktualizace existujících objektů). Pokud není předáno ID vrstvy, nejprve se založí nová vrstva podle pevné definice. Vrátí okamžitě stav úlohy s jobId; průběh se zjišťuje přes /api/import/json/progress.
         * @param {JsonImportRunVO} [jsonImportRunVO] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async runJsonImport(jsonImportRunVO?: JsonImportRunVO, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<JsonImportProgressVO>> {

            const localVarAxiosArgs = await localVarAxiosParamCreator.runJsonImport(jsonImportRunVO, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Nahraje JSON soubor POV, projde ho a vrátí počty objektů, které se založí a které se aktualizují (ztotožnění přes externí id). Bez parametru layerId jde o import do nové vrstvy (vrstva se založí podle pevné definice až při spuštění importu) – všechny objekty jsou pak nové.
         * @param {number} [layerId] ID cílové vrstvy; prázdné &#x3D; import do nové vrstvy
         * @param {File} [file] JSON soubor s daty
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async uploadJson(layerId?: number, file?: File, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<JsonImportCheckVO>> {

            const localVarAxiosArgs = await localVarAxiosParamCreator.uploadJson(layerId, file, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * JsonImportControllerApi - factory interface
 * @export
 */
export const JsonImportControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = JsonImportControllerApiFp(configuration)
    return {
        /**
         * Vrátí průběžný stav úlohy importu/aktualizace běžící na pozadí
         * @param {string} jobId identifikátor úlohy vrácený při spuštění importu/aktualizace
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getJsonImportProgress(jobId: string, options?: any): AxiosPromise<JsonImportProgressVO> {
            return localVarFp.getJsonImportProgress(jobId, options).then((request) => request(axios, basePath));
        },
        /**
         * Vrátí poslední známý průběh importu/aktualizace pro danou vrstvu (běžící i nedávno dokončený), aby ho bylo možné zobrazit v detailu vrstvy i po zavření okna importu. Prázdné, pokud pro vrstvu žádná úloha není evidována.
         * @param {number} layerId ID vrstvy
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getJsonImportProgressForLayer(layerId: number, options?: any): AxiosPromise<JsonImportProgressVO> {
            return localVarFp.getJsonImportProgressForLayer(layerId, options).then((request) => request(axios, basePath));
        },
        /**
         * Spustí na pozadí import dat ze nahraného souboru (včetně obrázků) podle zvolených akcí (vložení nových a/nebo aktualizace existujících objektů). Pokud není předáno ID vrstvy, nejprve se založí nová vrstva podle pevné definice. Vrátí okamžitě stav úlohy s jobId; průběh se zjišťuje přes /api/import/json/progress.
         * @param {JsonImportRunVO} [jsonImportRunVO] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        runJsonImport(jsonImportRunVO?: JsonImportRunVO, options?: any): AxiosPromise<JsonImportProgressVO> {
            return localVarFp.runJsonImport(jsonImportRunVO, options).then((request) => request(axios, basePath));
        },
        /**
         * Nahraje JSON soubor POV, projde ho a vrátí počty objektů, které se založí a které se aktualizují (ztotožnění přes externí id). Bez parametru layerId jde o import do nové vrstvy (vrstva se založí podle pevné definice až při spuštění importu) – všechny objekty jsou pak nové.
         * @param {number} [layerId] ID cílové vrstvy; prázdné &#x3D; import do nové vrstvy
         * @param {File} [file] JSON soubor s daty
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadJson(layerId?: number, file?: File, options?: any): AxiosPromise<JsonImportCheckVO> {
            return localVarFp.uploadJson(layerId, file, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * JsonImportControllerApi - interface
 * @export
 * @interface JsonImportControllerApi
 */
export interface JsonImportControllerApiInterface {
    /**
     * Vrátí průběžný stav úlohy importu/aktualizace běžící na pozadí
     * @param {string} jobId identifikátor úlohy vrácený při spuštění importu/aktualizace
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof JsonImportControllerApiInterface
     */
    getJsonImportProgress(jobId: string, options?: any): AxiosPromise<JsonImportProgressVO>;

    /**
     * Vrátí poslední známý průběh importu/aktualizace pro danou vrstvu (běžící i nedávno dokončený), aby ho bylo možné zobrazit v detailu vrstvy i po zavření okna importu. Prázdné, pokud pro vrstvu žádná úloha není evidována.
     * @param {number} layerId ID vrstvy
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof JsonImportControllerApiInterface
     */
    getJsonImportProgressForLayer(layerId: number, options?: any): AxiosPromise<JsonImportProgressVO>;

    /**
     * Spustí na pozadí import dat ze nahraného souboru (včetně obrázků) podle zvolených akcí (vložení nových a/nebo aktualizace existujících objektů). Pokud není předáno ID vrstvy, nejprve se založí nová vrstva podle pevné definice. Vrátí okamžitě stav úlohy s jobId; průběh se zjišťuje přes /api/import/json/progress.
     * @param {JsonImportRunVO} [jsonImportRunVO] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof JsonImportControllerApiInterface
     */
    runJsonImport(jsonImportRunVO?: JsonImportRunVO, options?: any): AxiosPromise<JsonImportProgressVO>;

    /**
     * Nahraje JSON soubor POV, projde ho a vrátí počty objektů, které se založí a které se aktualizují (ztotožnění přes externí id). Bez parametru layerId jde o import do nové vrstvy (vrstva se založí podle pevné definice až při spuštění importu) – všechny objekty jsou pak nové.
     * @param {number} [layerId] ID cílové vrstvy; prázdné &#x3D; import do nové vrstvy
     * @param {File} [file] JSON soubor s daty
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof JsonImportControllerApiInterface
     */
    uploadJson(layerId?: number, file?: File, options?: any): AxiosPromise<JsonImportCheckVO>;

}

/**
 * JsonImportControllerApi - object-oriented interface
 * @export
 * @class JsonImportControllerApi
 * @extends {BaseAPI}
 */
export class JsonImportControllerApi extends BaseAPI implements JsonImportControllerApiInterface {
    /**
     * Vrátí průběžný stav úlohy importu/aktualizace běžící na pozadí
     * @param {string} jobId identifikátor úlohy vrácený při spuštění importu/aktualizace
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof JsonImportControllerApi
     */
    public getJsonImportProgress(jobId: string, options?: any) {
        return JsonImportControllerApiFp(this.configuration).getJsonImportProgress(jobId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Vrátí poslední známý průběh importu/aktualizace pro danou vrstvu (běžící i nedávno dokončený), aby ho bylo možné zobrazit v detailu vrstvy i po zavření okna importu. Prázdné, pokud pro vrstvu žádná úloha není evidována.
     * @param {number} layerId ID vrstvy
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof JsonImportControllerApi
     */
    public getJsonImportProgressForLayer(layerId: number, options?: any) {
        return JsonImportControllerApiFp(this.configuration).getJsonImportProgressForLayer(layerId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Spustí na pozadí import dat ze nahraného souboru (včetně obrázků) podle zvolených akcí (vložení nových a/nebo aktualizace existujících objektů). Pokud není předáno ID vrstvy, nejprve se založí nová vrstva podle pevné definice. Vrátí okamžitě stav úlohy s jobId; průběh se zjišťuje přes /api/import/json/progress.
     * @param {JsonImportRunVO} [jsonImportRunVO] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof JsonImportControllerApi
     */
    public runJsonImport(jsonImportRunVO?: JsonImportRunVO, options?: any) {
        return JsonImportControllerApiFp(this.configuration).runJsonImport(jsonImportRunVO, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Nahraje JSON soubor POV, projde ho a vrátí počty objektů, které se založí a které se aktualizují (ztotožnění přes externí id). Bez parametru layerId jde o import do nové vrstvy (vrstva se založí podle pevné definice až při spuštění importu) – všechny objekty jsou pak nové.
     * @param {number} [layerId] ID cílové vrstvy; prázdné &#x3D; import do nové vrstvy
     * @param {File} [file] JSON soubor s daty
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof JsonImportControllerApi
     */
    public uploadJson(layerId?: number, file?: File, options?: any) {
        return JsonImportControllerApiFp(this.configuration).uploadJson(layerId, file, options).then((request) => request(this.axios, this.basePath));
    }
}
